<template>
  <modal
    name="contact-form"
    :minHeight="370"
    :width="500"
    :height="'auto'"
    :adaptive="true"
    :scrollable="false"
    :draggable="true"
    :clickToClose="false"

  >
   <div class="contact-form-vox">
      <div class="contact-form-vox__close" @click="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
        </svg>
      </div>
      <h3 class="contact-form-vox__title mt-2">Zapytaj o ofertę</h3>
      <form class="contact-form-vox__form mb-5" @submit.prevent="submitForm">
        <div class="contact-form-vox__group">
          <input
            class="contact-form-vox__input"
            type="text"
            v-model="formData.contact_name"
            placeholder="Imię i nazwisko *"
            @change="checkForm()"
          />
          <span class="contact-form-vox__error" v-if="nameError">{{ nameError }}</span>
        </div>
        <div class="contact-form-vox__group">
          <input
            class="contact-form-vox__input"
            type="text"
            v-model="formData.contact_email"
            placeholder="Email *"
             @change="checkForm()"
          />
          <span class="contact-form-vox__error" v-if="emailError">{{ emailError }}</span>
        </div>
        <div class="contact-form-vox__group">
          <input
            class="contact-form-vox__input"
            type="text"
            v-model="formData.contact_phone"
            placeholder="Telefon *"
             @change="checkForm()"
          />
          <span class="contact-form-vox__error" v-if="phoneError">{{ phoneError }}</span>
        </div>
        <div class="contact-form-vox__group">
          <textarea
            class="contact-form-vox__input"
            v-model="formData.contact_message"
            placeholder="Wiadomość"
          />
        </div>
        <div class="contact-form-vox__checkbox-group">
          <input class="contact-form-vox__checkbox" type="checkbox" id="zgoda1" v-model="formData.contact_acceptance1" @change="checkForm()"/>
          <label class="contact-form-vox__checkbox-label" for="zgoda1">
            Wyrażam zgodę na otrzymywanie informacji handlowych od Developme sp. z o.o. drogą elektroniczną na wskazany w formularzu numer telefonu oraz adres poczty elektronicznej.
          </label>
        </div>
    
        <div class="contact-form-vox__checkbox-group">
          <input class="contact-form-vox__checkbox" type="checkbox" id="zgoda2" v-model="formData.contact_acceptance2" @change="checkForm()"/>
          <label class="contact-form-vox__checkbox-label" for="zgoda2">
            Wyrażam zgodę na marketing bezpośredni Developme sp. z o.o. przy użyciu telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących.
          </label>
        </div>
  
        <div class="contact-form-vox__checkbox-group">
          <input class="contact-form-vox__checkbox" type="checkbox" id="zgoda3" v-model="formData.contact_acceptance3" @change="checkForm()"/>
          <label class="contact-form-vox__checkbox-label" for="zgoda3">
            Akceptuję treść <a :href="this.url + '/polityka-prywatnosci/'" target="_blank">Polityki Prywatności</a> Administratorem danych osobowych jest DevelopMe sp. z o.o. Dane osobowe będą przetwarzane w celu wskazanym w treści wyrażonej zgody, w celu realizacji zamówionego kontaktu, marketingu bezpośredniego własnych produktów i usług oraz obrony przed ewentualnymi roszczeniami oraz w celu wykonania obowiązków wynikających z przepisów prawa. Przysługuje Pani/Panu prawo do dostępu do danych, ich usunięcia, ograniczenia przetwarzania, przenoszenia, sprzeciwu, sprostowania oraz cofnięcia zgód w każdym czasie.
          </label>
        </div>
        <span class="contact-form-vox__error" v-if="zgodyError">{{ zgodyError }}</span>
  
        <button type="submit" class="contact-form-vox__submit">Wyślij</button>
      </form>
    </div>
  </modal>
</template>

<script>
import axios from "axios";
export default {
  props: ["flat"],
  data() {
    return {
      success: false,
      error: "",
      holder: "",
      formData: {
        contact_name: "",
        contact_email: "",
        contact_phone: "",
        contact_message: "Proszę o więcej informacji na temat lokalu " + this.flat,
        contact_flat: this.flat,
        contact_acceptance1: "",
        contact_acceptance2: "",
        contact_acceptance3: ""
      },
      nameError: "",
      emailError: "",
      phoneError: "",
      url: window.location.origin
      // url: "https://test.2qbs.pl"
    };
  },
  watch: {
    flat(newVal) {
      if (newVal) {
        this.formData.contact_message = "Proszę o więcej informacji na temat lokalu " + newVal;
        this.formData.contact_flat = newVal;
      }
    }
  },
  methods: {
    closeModal() {
      document.body.style.overflow = '';
      this.$modal.hide("contact-form");
    },
    checkForm() {
      this.nameError = "";
  this.emailError = "";
  this.phoneError = "";
  this.zgodyError = "";
      if (!this.formData.contact_name) {
        this.nameError = "Pole jest obowiązkowe"
        return false
      } else { this.nameError = "" }
        // Sprawdzenie poprawności e-maila
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(this.formData.contact_email)) {
    this.emailError = "Podaj poprawny adres e-mail";
    return false;
      } else {
        this.emailError = "";
      }
      if (!this.formData.contact_phone) {
        this.phoneError = "Pole jest obowiązkowe"
        return false
      }
      const phoneDigits = this.formData.contact_phone.replace(/\D/g, "");
if (phoneDigits.length < 9) {
  this.phoneError = "Numer zawiera co najmniej 9 cyfr";
  return false;
} else {
  this.phoneError = "";
}
if (
    !this.formData.contact_acceptance1 ||
    !this.formData.contact_acceptance2 ||
    !this.formData.contact_acceptance3
  ) {
    this.zgodyError = "Zaznaczenie wszystkich zgód jest obowiązkowe";
    return false;
  } else {
    this.zgodyError = "";
  }

    },
    submitForm() {
      // console.log('testtest')
      // console.log(this.formData)
      if (this.checkForm() != false) {
        axios
          .post(this.url + `/wp-json/twoqbs/v2/send`, this.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
  this.success = true;
  console.log(res);
  this.$fire({
    text: "Twoja wiadomość została wysłana.",
    type: "success",
    timer: 3000
  }).then(() => {
    this.$modal.hide("contact-form")
    this.formData.contact_message = "",
      this.formData.contact_flat = "",
      this.formData.contact_acceptance1 = "",
      this.formData.contact_acceptance2 = "",
      this.formData.contact_acceptance3 = ""
  });
})
.catch((err) => {
  this.success = false;
  console.log(err);
  this.error = "Wystąpił błąd podczas wysyłania wiadomości.";
});
      }
    },
  },
};
</script>

<style>
/* .contact-form-vox * { box-sizing: border-box !important; font-family: Arial, Helvetica, sans-serif !important; } */

.contact-form-vox {
  background: #fff;
  padding: 32px 16px 16px 16px;
  border-radius: 10px;
  max-width: 500px;
  width: 100%;
  min-width: 280px;
  margin: 0 auto;
  position: relative;
  display: block;
  box-sizing: border-box;
}

.contact-form-vox {
  background: #fff;
  padding: 32px 16px 16px 16px;
  border-radius: 10px;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
}

.contact-form-vox__close {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  z-index: 10;
}

.contact-form-vox__title {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #222;
  text-align: left;
}

.contact-form-vox__form {
  width: 100%;
}

.contact-form-vox__group {
  margin-bottom: 18px;
}

.contact-form-vox__label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #222;
  line-height: 1.3;
}

.contact-form-vox__required {
  color: red;
  font-size: 14px;
  margin-left: 2px;
}

.contact-form-vox__input {
  width: 100% !important;
  padding: 8px 10px !important;
  font-size: 14px !important;
  border: 1px solid #e1e1e1 !important;
  border-radius: 4px !important;
  background: #fff !important;
  color: #222 !important;
  margin-bottom: 2px!important;
  transition: border-color 0.2s!important;
  outline: none!important;
  box-shadow: none!important;
  resize: none!important;
}

.contact-form-vox__input:focus {
  border-color: #222;
}

.contact-form-vox__error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 2px;
  display: block;
}

.contact-form-vox__checkbox-group {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.contact-form-vox__checkbox {
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}

.contact-form-vox__checkbox-label {
  font-size: 12px;
  color: #222;
  line-height: 1.4;
  font-weight: 400;
  user-select: text;
}

.contact-form-vox__checkbox-label a {
  color: #222;
  text-decoration: underline;
}

.contact-form-vox__submit {
  width: 100%;
  background: #222;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.2s;
}

.contact-form-vox__submit:hover {
  background: #444;
}

.vm--overlay,
.vm--modal {
  z-index: 99999 !important;
}
</style>

